
<template>
  <section class="section">
    <div class="columns">
      <div class="column container is-8 main">
        <h1 class="title">Changes saving</h1>
        <a class="button is-success" v-on:click="download">Download</a>
        <span class="is-family-monospace" v-html="changesTxt"></span>

        <loading :active.sync="loading" :can-cancel="false" :is-full-page="false"></loading>
      </div>
    </div>
  </section>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";
import * as downloader from "../download";

String.prototype.replaceAll = function(search, replacement) {
  var target = this;
  return target.split(search).join(replacement);
};

export default {
  name: "changes-saving",
  components: { Loading },
  data() {
    return {
      loading: false,
      changesTxt: {},
      changesRaw: {},
      btype: "text/plain",
      saveType: "all",
      language: "english",
      fileType: "txt",
      grouping: "minor",
      tags: [],

      filterType: "All",
      searchingText: "",
      productId: -1,
      version: -1,

      fileLink: "",
      filename: "changes.txt"
    };
  },
  methods: {
    getCurrentVersion() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.HTTP.get("productVersions/current/" + this.productId)
          .then(response => {
            this.version = response.data.id;
            this.loading = false;
            resolve();
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
            reject();
          });
      });
    },
    getLastVersion() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.HTTP.get("productVersions/last/" + this.productId)
          .then(response => {
            this.loading = false;
            this.version = response.data.id;
            resolve();
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
            reject();
          });
      });
    },
    getProductsFile() {
      this.loading = true;
      this.HTTP.post("changes/products/file", {

      }).then(response => {

      }).catch(e => {
        console.log(e);
      });
    },
    getChangesTxt() {
      this.loading = true;
      this.HTTP.post("changes/product/file_v2", {
        productId: this.productId,
        fileType: this.fileType,
        grouping: this.grouping,
        filterType: this.filterType,
        tags: this.tags,
        fileType: this.fileType,
        language: this.language,
        version:
          this.saveType == "currentVersion" || this.saveType == "lastVersion"
            ? this.version
            : null
      })
        .then(response => {
          let chgs = response.data;
          if (chgs.length == 0)
            chgs +=
              "\nThere is no any changes in version " + this.version + "!";
          if (this.fileType == "txt" || this.fileType == "markdown") {
            this.changesTxt = chgs.replaceAll("\n", "<br>");
            this.filename =
              this.fileType == "markdown" ? "changes.md" : "changes.txt";
            this.btype = "text/plain";
            this.changesRaw = chgs;
          } else {
            this.changesTxt = JSON.stringify(chgs);
            this.filename = "changes.json";
            this.btype = "application/json";
            this.changesRaw = JSON.stringify(chgs);
          }
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    download() {
      let blob = new Blob([this.changesRaw]);
      downloader.download(blob, this.filename, this.btype);
    }
    // pushUrl() {
    //   this.$router.push({
    //     path: "ChangesSaving",
    //     query: {
    //       saveType: this.saveType,
    //       language: this.language
    //     }
    //   });
    // }
  },
  created() {
    this.saveType = this.$route.query.saveType;
    this.language = this.$route.query.language;
    this.fileType = this.$route.query.fileType;
    this.grouping = this.$route.query.grouping;

    this.productId = parseInt(this.$route.query.productId);
    this.searchingText = this.$route.query.search;
    this.filterType = this.$route.query.filterType;
    this.tags = this.$route.query.tags;

    if (this.saveType == "currentVersion")
      this.getCurrentVersion().then(() => {
        this.getChangesTxt();
      });
    else if (this.saveType == "lastVersion") {
      this.getLastVersion().then(() => {
        this.getChangesTxt();
      });
    } else this.getChangesTxt();
  },
  watch: {
    // $route(to, from) {
    //   this.saveType = to.query.saveType;
    //   this.language = to.query.language;
    //   this.productId = parseInt(to.query.productId);
    //   this.searchingText = to.query.search;
    //   this.filterType = to.query.filterType;
    //   this.getChangesTxt();
    // },
    // saveType: function(val) {
    //   this.pushUrl();
    // },
    // language: function(val) {
    //   this.pushUrl();
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/ChangesSaving.Vue